(function () {
  if (window.matchMedia('(hover: none), (pointer: coarse)').matches) return;

  var script = document.currentScript;
  var src = script && script.dataset && script.dataset.src;
  if (!src) return;

  var cursor = document.createElement('div');
  cursor.className = 'csc-cursor';
  cursor.setAttribute('aria-hidden', 'true');
  cursor.innerHTML =
    '<div class="csc-cursor__inner">' +
    '<img src="' + src + '" alt="" width="128" height="128" draggable="false">' +
    '</div>';

  function init() {
    document.body.appendChild(cursor);
    document.documentElement.classList.add('csc-cursor-ready');

    var idleTimer = null;
    var rafId = null;
    var x = 0, y = 0;

    function render() {
      cursor.style.transform = 'translate(' + x + 'px, ' + y + 'px)';
      rafId = null;
    }

    function onMove(e) {
      x = e.clientX;
      y = e.clientY;
      if (rafId === null) rafId = requestAnimationFrame(render);
      if (!cursor.classList.contains('is-active')) cursor.classList.add('is-active');
      if (cursor.classList.contains('is-idle')) cursor.classList.remove('is-idle');
      clearTimeout(idleTimer);
      idleTimer = setTimeout(function () { cursor.classList.add('is-idle'); }, 2000);
    }

    window.addEventListener('mousemove', onMove, { passive: true });
    window.addEventListener('mouseleave', function () { cursor.classList.remove('is-active'); });
    window.addEventListener('mouseenter', function () { cursor.classList.add('is-active'); });
  }

  if (document.body) init();
  else document.addEventListener('DOMContentLoaded', init);
})();
